export enum IPaymentGateway {
  STRIPE = 'STRIPE',
  REDSYS = 'REDSYS'
}

export enum IPaymentMethod {
  ONLINE = 'ONLINE'
}

export interface IPaymentConfig {
  gateway: IPaymentGateway
  customerId: string | null
  accountId: string | null
}

export interface IPaymentInit {
  gateway: IPaymentGateway
  clientSecret: string | null
  redsysSignatureVersion: string | null
  redsysMerchantParameters: string | null
  redsysSignature: string | null
  redsysUrl: string | null
}

export interface IPurchaseCompleteEvent {
  message: any
  targetOrigin: string
}

export interface IPendingRedsysPayment {
  reservationId: number
  userCreated: boolean
  purchaseCompleteEvent?: IPurchaseCompleteEvent
}
